import type { JSX } from 'react';

import { ThemeProvider } from '@change/ds-core-ui/next';

import { ClientRender } from '@change-corgi/core/react/ssr/render';

import {
	StarterDashboardV2BreakpointStateProvider,
	useStarterDashboardV2PageNotificationManagerContext,
} from 'src/app/pages/starterDashboardV2/pageContext';

import { PageBodyReskin } from '../components/PageBody/index_new';
import { PageHeader } from '../components/PageHeader';

export function LayoutReskin(): JSX.Element {
	/*
	Tracking page view is disabled to avoid double tracking during reskin experiment. The tracking is done in the
	original/control component. We would need to uncomment this when the reskin replaces the original component.
	 */
	// useTrackPageView();
	const {
		data: { notification },
	} = useStarterDashboardV2PageNotificationManagerContext();

	return (
		<ThemeProvider>
			{/* We depend on client breakpoints */}
			<ClientRender placeholder={<div className="h-16" />}>
				<StarterDashboardV2BreakpointStateProvider>
					<PageHeader />
					<div className="bg-fill-inverse-strong h-full w-full">
						{notification?.content}
						<PageBodyReskin />
					</div>
				</StarterDashboardV2BreakpointStateProvider>
			</ClientRender>
		</ThemeProvider>
	);
}
